module.exports = __webpack_public_path__ + "videos/video-aleo-ads-mobile.fdca1bf.mp4";